import NeoList2 from './neoList2';
export default NeoList2;